var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "grid", staticClass: "goods-grid" },
    [
      _vm._l(_vm.rows, function (goods) {
        return _c(
          "div",
          {
            key: goods.materialId,
            staticClass: "goods-cell",
            on: {
              click: function ($event) {
                return _vm.handleClick(goods)
              },
            },
          },
          [
            goods.discountExcluded === 1 || goods.discountExcluded === true
              ? _c("span", { staticClass: "no-discount-tag" }, [_vm._v("无折")])
              : _vm._e(),
            _c("div", { staticClass: "goods-img" }, [
              goods.imgName
                ? _c("img", { attrs: { src: _vm.imgUrl(goods.imgName) } })
                : _c("div", { staticClass: "img-placeholder" }, [
                    _vm._v(_vm._s(goods.name)),
                  ]),
            ]),
            _c(
              "div",
              { staticClass: "goods-name", attrs: { title: goods.name } },
              [_vm._v(_vm._s(goods.name))]
            ),
            _c(
              "div",
              { staticClass: "goods-price" },
              [
                goods.minPrice !== null && goods.minPrice !== undefined
                  ? [
                      _vm.hasMemberPrice(goods)
                        ? _c("span", { staticClass: "member-price" }, [
                            _vm._v("¥" + _vm._s(_vm.format(goods.minPrice))),
                          ])
                        : _vm._e(),
                      _vm.hasMemberPrice(goods)
                        ? _c("span", { staticClass: "origin-price" }, [
                            _vm._v("¥" + _vm._s(_vm.format(goods.minRetail))),
                          ])
                        : _vm._e(),
                      !_vm.hasMemberPrice(goods)
                        ? _c("span", { staticClass: "normal-price" }, [
                            _vm._v("¥" + _vm._s(_vm.format(goods.minPrice))),
                          ])
                        : _vm._e(),
                    ]
                  : _c("span", { staticClass: "normal-price" }, [_vm._v("--")]),
                goods.units && goods.units.length > 1
                  ? _c("span", { staticClass: "spec-tag" }, [_vm._v("多规格")])
                  : _vm._e(),
              ],
              2
            ),
          ]
        )
      }),
      !_vm.rows || !_vm.rows.length
        ? _c("div", { staticClass: "empty-tip" }, [_vm._v("暂无商品")])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }